export enum TransactionReportMode {
  AsyncReport = 'ASYNC_REPORT',
  InstantReport = 'INSTANT_REPORT',
}
